import type { CSSProperties } from 'react';

export const labelStyle: CSSProperties = {
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#374151',
  display: 'block',
  marginBottom: '0.375rem',
};

export const sectionTitleStyle: CSSProperties = {
  margin: '0 0 1rem 0',
  fontSize: '1rem',
  fontWeight: 600,
  color: '#111827',
};

export const modalTitleStyle: CSSProperties = {
  margin: '0 0 0.25rem 0',
  fontSize: '1.25rem',
  fontWeight: 600,
  color: '#111827',
};

export const modalSubtitleStyle: CSSProperties = {
  margin: 0,
  fontSize: '0.875rem',
  color: '#6b7280',
};

export const fieldHintStyle: CSSProperties = {
  fontSize: '0.75rem',
  color: '#6b7280',
  marginTop: '0.25rem',
};

export const inputStyle: CSSProperties = {
  width: '100%',
  padding: '0.625rem 0.75rem',
  border: '1px solid #e5e7eb',
  borderRadius: '6px',
  fontSize: '0.875rem',
  fontFamily: 'inherit',
  boxSizing: 'border-box',
};

export const readOnlyInputStyle: CSSProperties = {
  ...inputStyle,
  backgroundColor: '#f9fafb',
  color: '#374151',
  cursor: 'default',
};

export const buttonBaseStyle: CSSProperties = {
  padding: '0.5rem 1rem',
  borderRadius: '6px',
  fontSize: '0.875rem',
  fontWeight: 500,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

export const primaryButtonStyle: CSSProperties = {
  ...buttonBaseStyle,
  background: '#3b82f6',
  color: 'white',
  border: 'none',
};

export const secondaryButtonStyle: CSSProperties = {
  ...buttonBaseStyle,
  background: 'transparent',
  border: '1px solid #e5e7eb',
  color: '#111827',
};

export const dangerButtonStyle: CSSProperties = {
  ...buttonBaseStyle,
  background: '#dc2626',
  color: 'white',
  border: 'none',
};

export const closeButtonStyle: CSSProperties = {
  width: '36px',
  height: '36px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: '1px solid #e5e7eb',
  borderRadius: '8px',
  background: 'white',
  cursor: 'pointer',
  color: '#374151',
  padding: 0,
  flexShrink: 0,
};

export const modalOverlayStyle: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0, 0, 0, 0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 2000,
  padding: '1rem',
};

export const modalPanelStyle: CSSProperties = {
  background: 'white',
  borderRadius: '12px',
  boxShadow: '0 10px 25px rgba(0, 0, 0, 0.12)',
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '90vh',
  minHeight: 0,
  overflow: 'hidden',
  width: '100%',
};

export const modalHeaderStyle: CSSProperties = {
  padding: '1.5rem',
  borderBottom: '1px solid #e5e7eb',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexShrink: 0,
};

export const modalBodyStyle: CSSProperties = {
  padding: '1.5rem',
  overflowY: 'auto',
  flex: 1,
  minHeight: 0,
  overscrollBehavior: 'contain',
};

export const modalFooterStyle: CSSProperties = {
  padding: '1rem 1.5rem',
  borderTop: '1px solid #e5e7eb',
  display: 'flex',
  gap: '0.75rem',
  justifyContent: 'flex-end',
  flexShrink: 0,
};

export const FORM_MODAL_Z_INDEX = 2000;
export const NESTED_MODAL_Z_INDEX_OFFSET = 100;
/** Above ProcessingBatchExecutionView overlay (3200) and production-plan sub-modal (3300). */
export const PROCESSING_STEP_MODAL_Z_INDEX = 3350;

export const modalSizeWidths: Record<'sm' | 'md' | 'lg' | 'xl', string> = {
  sm: '420px',
  md: '500px',
  lg: '720px',
  xl: '900px',
};

export const errorBannerStyle: CSSProperties = {
  padding: '0.75rem 1rem',
  backgroundColor: '#fee2e2',
  color: '#b91c1c',
  borderRadius: '6px',
  marginBottom: '1rem',
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  fontSize: '0.875rem',
};
